import { getProgramTypeCacheStore } from 'legacy/lut/services/partner360/configuration/helpers/getProgramTypeCacheStore'
import { IState } from 'legacy/lut/store'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'
import { compose } from 'redux'

import { setPublishingMode } from 'core/store/appSlice'

import { changeProgramType } from '../api/changeProgramType'
import { changeOfferingsMode } from '../configurationSlice'
import { getAvailableProgramTypes } from '../helpers/getAvailableProgramTypes'
import { selectFinancialYear } from '../selectors/selectFinancialYear'
import { selectPartnerAccess } from '../selectors/selectPartnerAccess'
import { selectPartnerId } from '../selectors/selectPartnerId'
import { selectProgramTypes } from '../selectors/selectProgramTypes'

listenerMiddleware.startListening({
  actionCreator: changeOfferingsMode,
  effect: async (action, { getState, dispatch }) => {
    const getPublishingMode = (state: IState) => state.app.publishingMode
    const publishingMode = compose(getPublishingMode, getState)()
    const programTypes = compose(selectProgramTypes, getState)()
    const partnerId = compose(selectPartnerId, getState)()
    const fYear = compose(selectFinancialYear, getState)()
    const { isHybrid } = compose(selectPartnerAccess, getState)()
    const isNewOfferingsMode = action.payload
    const programTypeCache = getProgramTypeCacheStore()
    const partnerIdWithMode = isNewOfferingsMode
      ? `${partnerId}_${fYear}_new`
      : `${partnerId}_${fYear}_old`

    if (publishingMode) {
      dispatch(setPublishingMode(false))
    }

    const cachedProgramType = await programTypeCache.getById(partnerIdWithMode)
    const types = getAvailableProgramTypes(programTypes, {
      isNewOfferingsMode,
      isHybridPartner: isHybrid,
    }).filter((it) => it.enabled)

    if (cachedProgramType && types.some((it) => it.programType === cachedProgramType.programType)) {
      dispatch(changeProgramType(cachedProgramType.programType))
    } else {
      dispatch(changeProgramType(types[0].programType))
    }
  },
})
